import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import RoutesForIndustryOnly from './RoutesForIndustryOnly';
import RoutesForFreeLicense from './RoutesForFreeLicense';
import RoutesForRegularRoles from './RoutesForRegularRoles';
import RoutesForATMSystemRoles from './RoutesForATMSystemRoles';
import RoutesForDeactivatedUsers from './RoutesForDeactivatedUsers';
import PrivilegeNames from '../../../constants/privilegeNames';
import GET_CURRENT_USER from '../queries/currentUserQuery';
import {
  userLicensedOrgId,
  userLicensedOrgUnitId,
  userPrivileges,
  systemRole,
  supplementalRole,
  userTier,
  userInfo
} from '../../../apollo/cache';
import { isUserOrgUnitTier } from '../services/checkUserTierService';
import { getToken } from '../../../utils/auth';
import { useClientSessionOmitter } from '@shared/hooks/useClientSessionOmitter';
import { INTERNAL_ATM } from '../../../constants/system-roles';

const AppRoutes = () => {
  const { endMashboardSession } = useClientSessionOmitter();
  const { data, error: userLoadingError, loading } = useQuery(GET_CURRENT_USER);

  useEffect(() => {
    if (!data || !data.currentUser) {
      return;
    }

    userInfo(data.currentUser);
    systemRole(data.currentUser.SystemRole);
    supplementalRole(data.currentUser.SupplementalRole);
    userPrivileges(data.currentUser.Privileges);
    userTier(data.currentUser.Tier);
    userLicensedOrgId(data.currentUser.LicensedOrgId);

    if (isUserOrgUnitTier(data.currentUser.Tier)) {
      userLicensedOrgUnitId(data.currentUser.LicensedOrgUnitId);
    }
  }, [data]);

  if (loading) {
    return null;
  }

  if (!getToken() || userLoadingError) {
    endMashboardSession();
    return null;
  }

  const UserRoutesComponent = selectRoutesComponent(data.currentUser);

  return <UserRoutesComponent />;
};

const routesMapping = {
  DeactivatedLicense: {
    condition: currentUser => currentUser.IsDeactivated,
    component: RoutesForDeactivatedUsers
  },
  RegularRoles: {
    condition: currentUser => currentUser.Privileges.includes(PrivilegeNames.WelcomePage),
    component: RoutesForRegularRoles
  },
  VIPPartner: {
    condition: currentUser => currentUser.Privileges.includes(PrivilegeNames.IndustryReports),
    component: RoutesForIndustryOnly
  },
  ATMSystemRoles: {
    condition: currentUser => currentUser.SystemRole.Id === INTERNAL_ATM,
    component: RoutesForATMSystemRoles
  },
  FreeLicense: {
    condition: _ => true,
    component: RoutesForFreeLicense
  }
};

const selectRoutesComponent = currentUser => {
  const matchedRoutes = Object.values(routesMapping).find(({ condition }) =>
    condition(currentUser)
  );

  return matchedRoutes.component;
};

export default AppRoutes;
